import { render, staticRenderFns } from "./MenuChoices.vue?vue&type=template&id=2d16db50&"
import script from "./MenuChoices.vue?vue&type=script&lang=js&"
export * from "./MenuChoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports